module.exports = __webpack_public_path__ + "static/media/network.57be2c25.svg";